import { calendarConstants } from '../_constants/calendar.constants';

// Search calendar by year
export const fetchCalendarByYearStart = (data) => ({
  type: calendarConstants.FETCH_CALENDAR_BY_YEAR_START,
  payload: data
});
export const fetchCalendarByYearSuccess = (data) => ({
  type: calendarConstants.FETCH_CALENDAR_BY_YEAR_SUCCESS,
  payload: data
});
export const fetchCalendarByYearFailure = (errorMessage) => ({
  type: calendarConstants.FETCH_CALENDAR_BY_YEAR_FAILURE,
  payload: errorMessage
});
export const updateCalendarYear = (year) => ({
  type: calendarConstants.UPDATE_CALENDAR_YEAR,
  payload: year
});
export const updateUserFundCalendar= (fund) => ({
  type: calendarConstants.UPDATE_USER_FUND_CALENDAR,
  payload: fund
});

// Search fund calendar by date
export const fetchCalendarByDateStart = (data) => ({
  type: calendarConstants.FETCH_CALENDAR_BY_DATE_START,
  payload: data
});
export const fetchCalendarByDateSuccess = (data) => ({
  type: calendarConstants.FETCH_CALENDAR_BY_DATE_SUCCESS,
  payload: data
});
export const fetchCalendarByDateFailure = (errorMessage) => ({
  type: calendarConstants.FETCH_CALENDAR_BY_DATE_FAILURE,
  payload: errorMessage
});
export const updateUserCalendarDate = (date) => ({
  type: calendarConstants.UPDATE_USER_CALENDAR_DATE,
  payload: date
})
